export default class LenisWrapper {
    constructor() {
        this.lenis = new Lenis();
        this.init();
    }

    init() {
        this.lenis.on("scroll", (e) => {
            ScrollTrigger.update();
        });

        gsap.ticker.add((time) => {
            this.lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);
    }
}
